import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { HttpClientModule } from "@angular/common/http";
import { IonicStorageModule } from "@ionic/storage";
import { Camera } from "@ionic-native/camera/ngx";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { Clipboard } from "@ionic-native/clipboard/ngx";
import { QRCodeModule } from "angularx-qrcode";
import { QRScanner } from "@ionic-native/qr-scanner/ngx";
import { SocialSharing } from "@awesome-cordova-plugins/social-sharing/ngx";
import { FingerprintAIO } from "@ionic-native/fingerprint-aio/ngx";
import { TransactionPageModule } from "./modals/transaction/transaction.module";
import { TransactionPage } from "./modals/transaction/transaction.page";
import { WithdrawPageModule } from "./modals/withdraw/withdraw.module";
import { StakingPageModule } from "./modals/staking/staking.module";
import { Device } from "@awesome-cordova-plugins/device/ngx";
import { SelectaccountPage } from "./modals/selectaccount/selectaccount.page";
import { SelectaccountPageModule } from "./modals/selectaccount/selectaccount.module";
import { AssetTransactionPage } from "./modals/asset-transaction/asset-transaction.page";
import { AssetTransactionPageModule } from "./modals/asset-transaction/asset-transaction.module";
import { SelectFromAssetPage } from "./modals/select-from-asset/select-from-asset.page";
import { SelectToAssetPage } from "./modals/select-to-asset/select-to-asset.page";
import { SelectFromAssetPageModule } from "./modals/select-from-asset/select-from-asset.module";
import { SelectToAssetPageModule } from "./modals/select-to-asset/select-to-asset.module";
import { ConfirmSwapPage } from "./modals/confirm-swap/confirm-swap.page";
import { ConfirmSwapPageModule } from "./modals/confirm-swap/confirm-swap.module";
import { SelectStakingWalletPage } from "./modals/select-staking-wallet/select-staking-wallet.page";
import { SelectStakingWalletPageModule } from "./modals/select-staking-wallet/select-staking-wallet.module";
import { ConfirmStakingPage } from "./modals/confirm-staking/confirm-staking.page";
import { ConfirmStakingPageModule } from "./modals/confirm-staking/confirm-staking.module";
import { WithdrawKaudiPage } from "./modals/withdraw-kaudi/withdraw-kaudi.page";
import { WithdrawKaudiPageModule } from "./modals/withdraw-kaudi/withdraw-kaudi.module";

@NgModule({
  declarations: [AppComponent],
  entryComponents: [
    SelectaccountPage,
    TransactionPage,
    AssetTransactionPage,
    SelectFromAssetPage,
    SelectToAssetPage,
    ConfirmSwapPage,
    SelectStakingWalletPage,
    ConfirmStakingPage,
    WithdrawKaudiPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    QRCodeModule,
    SelectaccountPageModule,
    TransactionPageModule,
    WithdrawPageModule,
    StakingPageModule,
    AssetTransactionPageModule,
    SelectFromAssetPageModule,
    SelectToAssetPageModule,
    ConfirmSwapPageModule,
    SelectStakingWalletPageModule,
    ConfirmStakingPageModule,
    WithdrawKaudiPageModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    InAppBrowser,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    Camera,
    Clipboard,
    QRScanner,
    SocialSharing,
    FingerprintAIO,
    Device,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
